import { render, staticRenderFns } from "./customOpptyClosedReason.vue?vue&type=template&id=04a5cca0&lang=pug"
import script from "./customOpptyClosedReason.vue?vue&type=script&lang=js"
export * from "./customOpptyClosedReason.vue?vue&type=script&lang=js"
import style0 from "./customOpptyClosedReason.vue?vue&type=style&index=0&id=04a5cca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports